import { Component, Input } from '@angular/core';

@Component({
    selector: "slide-ajax-div",
    template: `Hello Loading something delecious`
})
export class SlideAjaxDivComponent {
    @Input("url") meta: any;
    constructor() {

    }
}


// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/libs/carousel/slide/slide-ajax-div.component.ts